module.exports = __webpack_public_path__ + "img/img-115.3848ac50.png";